<template>
  <div>
    <input
      :id="getId()"
      :value="value"
      class="form-control"
      type="url"
      placeholder="https://"
      :disabled="disabled"
      @input="fieldInputChanged($event.target.value)"
      @blur="validate"
    />
    <template
      v-if="(field.url2png || field.urlReferenceId) && value === field.value"
      v-slot:field-footer
    >
      <br />
      <url-field-embed-preview
        :url-type="field.urlType"
        :url="field.value"
        :external-url="field.externalUrl"
        :url-reference-id="field.urlReferenceId"
        :url2png="field.url2png"
      ></url-field-embed-preview>
    </template>
  </div>
</template>

<script>
import Field from './Field.vue';
import UrlFieldEmbedPreview from './UrlFieldEmbedPreview';

export default {
  components: { UrlFieldEmbedPreview },
  extends: Field,
  data() {
    return {
      validationRules: ['url']
    };
  },
  methods: {
    fieldInputChanged(value) {
      if (
        value &&
        !value.startsWith('http://') &&
        !value.startsWith('https://')
      ) {
        value = 'https://' + value;
      }
      this.onInput(value);
    }
  }
};
</script>
